import React from 'react';
import PropTypes from 'prop-types';
import styles from 'components/layout/OutdatedBrowser/styles';
import translate from 'components/hoc/translate';

class OutdatedBrowser extends React.PureComponent {
    state = {
        open: true,
    }

    closeBar() {
        this.setState({
            open: false,
        });
    }

    render() {
        if (!this.state.open) {
            return null;
        }

        const { type } = this.props;

        return (
            <div style={ styles[type] }>

                <div style={ { ...styles.title, ...styles[type].title } }>
                    { this.props.translate('elements.outdatedBrowser.title') }
                </div>

                <div style={ styles[type].info }>
                    <div style={ { ...styles.description, ...styles[type].description } }>
                        { this.props.translate('elements.outdatedBrowser.description') }
                    </div>

                    <a
                        style={ styles[type].link }
                        href='https://browser-update.org/update.html'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        { this.props.translate('elements.outdatedBrowser.linkText') }
                    </a>
                </div>

                <button
                    style={ styles.button }
                    onClick={ () => {
                        return this.closeBar();
                    } }
                >+</button>
            </div>
        );
    }
}

OutdatedBrowser.defaultProps = {
    type: 'box',
};

OutdatedBrowser.propTypes = {
    translate: PropTypes.func,
    type: PropTypes.string,
};

export default translate(OutdatedBrowser);



// WEBPACK FOOTER //
// ./src/components/layout/OutdatedBrowser/OutdatedBrowser.js